import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { Typography, Box, Paper, Grid } from '@material-ui/core';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import { graph_mock, allpoint } from '../../../mockdata/dashboard/mock-graph-2';
import SummaryBoxesTotalPoint from '../../../components/Dashboard/SummaryBox/TotalPoint';
import FilterYear from '../../../components/Dashboard/Filter/Year';
import Filter from '../../../components/Dashboard/Filter/ActivityFilterByYear-6level-Date';
import EmptyChart from '../../../components/Dashboard/Chart/EmptyChart';
import DownloadPDFButton from '../../../components/Dashboard/Button/DownloadPDF';
import { useLocation } from 'react-router-dom';

let mock = false;

const Activity = () => {
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingGraph, setIsLoadingGraph] = useState(false);
   const [year, setYear] = useState(null);
   const [chartData, setChartData] = useState();
   const [totalPoint, setTotalPoint] = useState();
   const [isLoadingSummaryBoxes, setIsLoadingSummaryBoxes] = useState(false);
   const [filtersData, setFiltersData] = useState();
   const location = useLocation();
   const getChartsOptionsDefault = () => {
      return {
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               type: 'shadow',
            },
         },
         legend: {},
         grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: [
            {
               type: 'category',
               axisLabel: { rotate: 90 },
               data: null,
            },
         ],
         yAxis: [
            {
               name: 'คะแนน',
               type: 'value',
            },
         ],
         series: [
            {
               color: '#F383BB',
               name: 'จำนวนคะแนน G',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#633C21',
               name: 'จำนวนคะแนน S',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#EDD221',
               name: 'จำนวนคะแนน B',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
         ],
      };
   };
   const onChangeYear = (year) => {
      setYear(year);
      let payload = { year };
      setIsLoadingSummaryBoxes(true);
      Axios.get('/GSB/dashboard/dashboard/GetTotalPoint', { params: payload })
         .then((resp) => {
            setTotalPoint({
               ...resp.data,
               year,
            });
            // enqueueSnackbar('ดึงข้อมูลคะแนนสำเร็จ', { variant: 'success' });
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(e.response.data.errorAppMessageTh, {
                  variant: 'error',
               });
            } else {
               console.error('site error');
            }
         })
         .finally(() => {
            setIsLoadingSummaryBoxes(false);
         });
   };
   const onFiltersSubmit = (filters) => {
      setFiltersData(filters);
      let payload = {
         divisionList: filters.shortCodes,
         startDate: filters.startDateString,
         endDate: filters.endDateString,
         activityId: filters.activity && filters.activity.activityId,
      };
      if (mock) {
         setIsLoadingGraph(true);
         setTimeout(() => {
            setIsLoadingGraph(false);
            setChartData(graph_mock.graph);
         }, 1000);
      } else {
         setIsLoadingGraph(true);
         Axios.post('/GSB/dashboard/dashboard/GetActivityGraph', payload)
            .then((resp) => {
               setChartData(resp.data.graph);
               // enqueueSnackbar('ดึงข้อมูลกราฟสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               setChartData(null);
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else console.error('site error');
            })
            .finally(() => {
               setIsLoadingGraph(false);
            });
      }
   };
   const mapOptions = (data) => {
      let xAxisData = data.map((el) => el.groupName);
      let G = data.map((el) => el.gTotalPoints);
      let S = data.map((el) => el.sTotalPoints);
      let B = data.map((el) => el.bTotalPoints);
      let options = getChartsOptionsDefault();
      options.xAxis[0].data = xAxisData;
      options.series[0].data = G;
      options.series[1].data = S;
      options.series[2].data = B;
      return options;
   };
   return (
      <div>
         <Box margin={'10px 0px'} textAlign={'end'}>
            <DownloadPDFButton
               disabled={isLoadingGraph || isLoadingSummaryBoxes}
               to={() => {
                  localStorage.setItem(
                     'report',
                     JSON.stringify({ totalPoint, filtersData, chartData }),
                  );
                  return {
                     pathname: location.pathname + '/report',
                  };
               }}
            />
         </Box>
         <Paper>
            <Box padding={'10px'}>
               <Box>
                  <Typography variant='h5'>
                     แสดงคะแนนกิจกรรมแบ่งตามสังกัด
                  </Typography>
                  <Box>
                     <Grid xs={2}>
                        <FilterYear
                           onChangeYear={onChangeYear}
                           defaultSubmitFirstParams
                        />
                     </Grid>
                     <Box marginTop={'10px'}>
                        <SummaryBoxesTotalPoint
                           totalPoint={totalPoint}
                           isLoading={isLoadingSummaryBoxes}
                        />
                     </Box>
                  </Box>
                  <Box marginTop={'10px'}>
                     <Filter
                        year={year}
                        isLoading={isLoadingGraph}
                        onSubmit={onFiltersSubmit}
                        defaultSubmitFirstParams={false}
                        isAllLevelSelectMultiple
                     />
                  </Box>
               </Box>
               <Box padding={'10px'}>
                  {chartData ? (
                     <ReactECharts
                        option={mapOptions(chartData)}
                        style={{ height: 400, width: '100%' }}
                     />
                  ) : (
                     <EmptyChart
                        text={'โปรดระบุตัวกรองด้านบนเพื่อแสดงกราฟ'}
                        show={true}
                        height={400}
                     />
                  )}
               </Box>
            </Box>
         </Paper>
      </div>
   );
};

export default Activity;
